<template>
  <div
    :class="{ 'tw:bg-white/70 tw:backdrop-blur-xs tw:shadow-xs': isScrolled }"
    aria-label="main navigation"
    class="tw:fixed tw:w-full tw:px-4 tw:md:px-6 tw:py-4 tw:flex tw:items-center tw:justify-between tw:z-20 tw:transition-all tw:duration-300"
    role="banner"
  >
    <a aria-label="edrone homepage" href="https://edrone.me/">
      <img
        alt="Logo edrone"
        class="tw:h-full"
        loading="eager"
        src="https://d3vhsxl1pwzf0p.cloudfront.net/logo-edrone-menu.svg"
      />
    </a>
    <div class="tw:flex tw:items-center tw:gap-4">
      <a v-if="!isMobile" class="tw:hidden tw:md:inline-block" @click="goto">
        <EdroneButton type="text">{{ redirection.text }}</EdroneButton>
      </a>
      <EdroneSelectCustom
        v-if="!isMobile"
        :allow-empty="false"
        :options="langOptions"
        :selected-options="selectedLangOption"
        aria-label="Choose language"
        class="tw:w-[9.375rem]"
        @select="onLangChange"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue";
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneSelectCustom from "edrone-components/EdroneSelectCustom.vue";

export default defineComponent({
  name: "AccountMenu",
  components: {
    EdroneButton,
    EdroneSelectCustom,
  },
  props: {
    redirection: {
      type: Object,
      default: () => ({
        path: "/login",
        text: "Log in",
      }),
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const translations = window._trans["lang"];
    const localLang = ref(translations);
    const isScrolled = ref(false);

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 10;
    };

    const langOptions = computed(() => {
      return [
        { value: "pl", name: "Polski" },
        { value: "en", name: "English" },
        { value: "pt", name: "Português" },
        { value: "es", name: "Español" },
      ];
    });

    const selectedLangOption = computed(() => {
      return langOptions.value.find((option) => option.value === localLang.value);
    });

    function onLangChange(option: { value: string; name: string } | undefined) {
      if (!option) return;
      localLang.value = option.value;
      if (window.location.search) {
        let searchParams = window.location.search;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        searchParams.includes("lang")
          ? (searchParams = searchParams.replace(/lang=../, "lang=" + option.value))
          : (searchParams = searchParams + "&lang=" + option.value);
        window.location.href = window.location.pathname + searchParams;
      } else {
        window.location.href = window.location.href + "?lang=" + option.value;
      }
    }

    function goto() {
      window.location.href = props.redirection.path + window.location.search;
    }

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    return {
      goto,
      isScrolled,
      langOptions,
      selectedLangOption,
      onLangChange,
    };
  },
});
</script>

<style lang="scss">
@use "vue-app/assets/scss/views/account/account.scss";

.AccountMenu {
  padding: 0 !important;
  position: static !important;
}
</style>
